// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"476":"e223a912","837":"d75f6e10"}[chunkId] + ".chunk.css";
};